const independentSamplings = [
    {
        "uuid": "1",
        "appNo": "21112001",
        "customerNo": "0004",
        "customerName": "中農粉絲有限公司",
        "assessmentPlace": "台東廠",
        "createdOn": "2021-11-10T08:20:10.000Z",
        "creator": "王小白",
        "samplingDates": [{"samplingDate": "2022-01-03T00:00:00.000Z"}, {"samplingDate": "2022-01-04T00:00:00.000Z"}],
        "sampleInfos": [
            {
                "product":"01",
                "testType":"finishedGood",
                "testName":"杏仁玄米餅",
                "finishedGoodTestName":"杏仁玄米餅",
                "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"台東廠",
                "originPlace":"台灣",
                "testResult":"qualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-12-31T08:20:10.000Z",
                "packingSpec":"200g/盒",
                "samplingInstruction":"於廠內連續批次生產時，可指為一個批次生產產品中抽取的一個單位 包裝或一次採樣盛裝量"
            },
            {
                "product":"03",
                "testType":"rawMaterial",
                "testName":"桂圓四物飲-原料1",
                "rawMaterialTestName":"01",
                "testItems":[{testItem:"04", details:["0401"]},{testItem:"05", details:["0501","0502"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"原料1製造商",
                "originPlace":"美國",
                "testResult":"unqualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-09-13T08:20:10.000Z",
                "samplingInstruction":"於廠內連續批次生產時，可指為一個批次生產產品中抽取的一個單位 包裝或一次採樣盛裝量"
            },
            {
                "product":"07",
                "testType":"finishedGood",
                "testName":"Natural Benefits 純在葡萄柚蘋果綠茶",
                "finishedGoodTestName":"Natural Benefits 純在葡萄柚蘋果綠茶",
                "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":false,
                "samplingFrequency":"year",
                "sampleManufacture":"台東廠",
                "originPlace":"台灣",
                "testResult":"qualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-12-31T08:20:10.000Z",
                "packingSpec":"200g/盒",
                "samplingInstruction":"於廠內連續批次生產時，可指為一個批次生產產品中抽取的一個單位 包裝或一次採樣盛裝量"
            },
            {
                "product":"04",
                "testType":"rawMaterial",
                "rawMaterialTestName":"01",
                "testItems":[{testItem:"04", details:["0401"]},{testItem:"05", details:["0501","0502"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":false,
                "samplingFrequency":"year",
                "sampleManufacture":"原料1製造商",
                "originPlace":"美國",
                "testResult":"unqualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-09-13T08:20:10.000Z",
                "samplingInstruction":"於廠內連續批次生產時，可指為一個批次生產產品中抽取的一個單位 包裝或一次採樣盛裝量"
            },
            {
                "product":"02",
                "testType":"finishedGood",
                "testName":"Pasta義大利麵",
                "finishedGoodTestName":"Pasta義大利麵",
                "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"台東廠",
                "originPlace":"台灣",
                "testResult":"qualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-12-31T08:20:10.000Z",
                "packingSpec":"200g/盒",
                "samplingInstruction":"於廠內連續批次生產時，可指為一個批次生產產品中抽取的一個單位 包裝或一次採樣盛裝量"
            },
            {
                "product":"05",
                "testType":"rawMaterial",
                "testName":"Natural Benefits 純在-蔬菜綜合果汁",
                "rawMaterialTestName":"01",
                "testItems":[{testItem:"04", details:["0401"]},{testItem:"05", details:["0501","0502"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"原料1製造商",
                "originPlace":"美國",
                "testResult":"unqualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-09-13T08:20:10.000Z",
                "samplingInstruction":"於廠內連續批次生產時，可指為一個批次生產產品中抽取的一個單位 包裝或一次採樣盛裝量"
            }
        ],
    },
    {
        "uuid": "2",
        "appNo": "21111922",
        "customerNo": "0003",
        "customerName": "黑松股份有限公司",
        "assessmentPlace": "台南廠",
        "createdOn": "2021-11-12T08:20:10.000Z",
        "creator": "張小華",
        "samplingDates": [{"samplingDate": "2022-01-03T00:00:00.000Z"}, {"samplingDate": "2022-01-04T00:00:00.000Z"}],
        "sampleInfos": [
            {
                "product":"01",
                "testType":"finishedGood",
                "testName":"杏仁玄米餅",
                "finishedGoodTestName":"杏仁玄米餅",
                "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"台東廠",
                "originPlace":"台灣",
                "testResult":"qualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-12-31T08:20:10.000Z",
                "packingSpec":"200g/盒",
                "samplingInstruction":"於廠內連續批次生產時，可指為一個批次生產產品中抽取的一個單位 包裝或一次採樣盛裝量"
            },
            {
                "product":"03",
                "testType":"rawMaterial",
                "testName":"桂圓四物飲-原料1",
                "rawMaterialTestName":"01",
                "testItems":[{testItem:"04", details:["0401"]},{testItem:"05", details:["0501","0502"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"原料1製造商",
                "originPlace":"美國",
                "testResult":"unqualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-09-13T08:20:10.000Z",
                "samplingInstruction":"於廠內連續批次生產時，可指為一個批次生產產品中抽取的一個單位 包裝或一次採樣盛裝量"
            },
            {
                "product":"07",
                "testType":"finishedGood",
                "testName":"Natural Benefits 純在葡萄柚蘋果綠茶",
                "finishedGoodTestName":"Natural Benefits 純在葡萄柚蘋果綠茶",
                "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":false,
                "samplingFrequency":"year",
                "sampleManufacture":"台東廠",
                "originPlace":"台灣",
                "testResult":"qualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-12-31T08:20:10.000Z",
                "packingSpec":"200g/盒",
                "samplingInstruction":"於廠內連續批次生產時，可指為一個批次生產產品中抽取的一個單位 包裝或一次採樣盛裝量"
            },
            {
                "product":"04",
                "testType":"rawMaterial",
                "rawMaterialTestName":"01",
                "testItems":[{testItem:"04", details:["0401"]},{testItem:"05", details:["0501","0502"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":false,
                "samplingFrequency":"year",
                "sampleManufacture":"原料1製造商",
                "originPlace":"美國",
                "testResult":"unqualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-09-13T08:20:10.000Z",
                "samplingInstruction":"於廠內連續批次生產時，可指為一個批次生產產品中抽取的一個單位 包裝或一次採樣盛裝量"
            },
            {
                "product":"02",
                "testType":"finishedGood",
                "testName":"Pasta義大利麵",
                "finishedGoodTestName":"Pasta義大利麵",
                "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"台東廠",
                "originPlace":"台灣",
                "testResult":"qualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-12-31T08:20:10.000Z",
                "packingSpec":"200g/盒",
                "samplingInstruction":"於廠內連續批次生產時，可指為一個批次生產產品中抽取的一個單位 包裝或一次採樣盛裝量"
            },
            {
                "product":"05",
                "testType":"rawMaterial",
                "testName":"Natural Benefits 純在-蔬菜綜合果汁",
                "rawMaterialTestName":"01",
                "testItems":[{testItem:"04", details:["0401"]},{testItem:"05", details:["0501","0502"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"原料1製造商",
                "originPlace":"美國",
                "testResult":"unqualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-09-13T08:20:10.000Z",
                "samplingInstruction":"於廠內連續批次生產時，可指為一個批次生產產品中抽取的一個單位 包裝或一次採樣盛裝量"
            }
        ],
    },
]

export default independentSamplings;